import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=1c1fa98a&scoped=true&"
import script from "./smsTemplate.vue?vue&type=script&lang=js&"
export * from "./smsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1fa98a",
  null
  
)

export default component.exports